import $ from "jquery";

export default class Feature {
  constructor() {
    this.example = 'example';
  }

  init() {
    this.example = 'initialized';
    console.log("init this ************");
  }
}



// WEBPACK FOOTER //
// /opt/jenkins_home/workspace/marketing-campaigns_deploy_trigger_imp/package/src/diverse-owned-brands.js